export enum ModalCloseOptions {
  CANCEL = 'CANCEL',
  CLEAR = 'CLEAR',
  CLEAR_LIST = 'CLEAR_LIST',
  CONFIRM = 'CONFIRM',
  DELETE = 'DELETE',
  OK = 'OK',
  REMOVE = 'REMOVE',
  SAVE = 'SAVE',
}
